module.exports = __webpack_public_path__ + "static/media/header_album_yokohama72184a03f0b69bda6b3273a39c731f2e.webp";